import AEMWrapper from "aem/ComponentWrapper";

import meta from "./aem-meta";

import EditorialText from ".";

export default AEMWrapper(meta, EditorialText);
